import api from '~/utils/api';
import { ParamsAnalysisExtension } from '~/pages/Portal/Settings/AutomaticAnalysis/AutomaticAnalysis';

export const patchParamsExtentionAnalysis = async (
  obj: Partial<ParamsAnalysisExtension>,
): Promise<any> => {
  const { data } = await api.patch<ParamsAnalysisExtension>(
    '/parametros-analise-extensao-automatica/update-params/',
    obj,
  );

  return data;
};

export const getParamsExtentionAnalysis = async (): Promise<any> => {
  const { data } = await api.get<ParamsAnalysisExtension>(
    '/parametros-analise-extensao-automatica/get-params/',
  );

  return data;
};
